export const GET_PROFILEIMG_FILEPATH = 'GET_PROFILEIMG_FILEPATH'
export const SET_PROFILEIMG_FILEPATH = 'SET_PROFILEIMG_FILEPATH'
export const RECEIVED_PROFILEIMG_FILEPATH = 'RECEIVED_PROFILEIMG_FILEPATH'
export const POST_PROFILEIMG_SAVE = 'POST_PROFILEIMG_SAVE'

export const GET_PROFILEIMG_TOGGLE = 'GET_PROFILEIMG_TOGGLE'
export const SET_PROFILEIMG_TOGGLE = 'SET_PROFILEIMG_TOGGLE'



// WEBPACK FOOTER //
// ./src/store/modules/profileimg/mutation-types.js